import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ImpersonateIcon from 'atoms/Icons/Impersonate';
import LogoutIcon from 'atoms/Icons/LogoutIcon';
import ProfileIcon from 'atoms/Icons/ProfileIcon';
import cn from 'classnames';
import React, { useState } from 'react';
import { navigateToSignOut, setImpersonateDetails } from 'utils/authUtils';
import { useUserAuth } from 'utils/hooks/useUserAuth';
import { navigateToUrl } from 'utils/navigateUtils';

import s from './UserProfileBtn.module.scss';

const UserProfileBtn = ({ className }: { className?: string }) => {
  const authDetails = useUserAuth();

  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  const title = authDetails?.nickname || authDetails?.name || 'Profile';

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (anchorEl) {
      setAnchorEl(undefined);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(undefined);
  };

  const onSignOut = () => {
    navigateToSignOut();
  };

  const redirectUnapprovedUser = () => {
    if (authDetails.kycDone) {
      navigateToUrl('/profile/financial');
      return;
    }
    navigateToUrl('/connect/welcome');
  };

  const onStopImpersonateUser = () => {
    setImpersonateDetails();
    navigateToUrl('/admin/users?impersonated=false', { reload: true });
  };

  return (
    <Button
      className={cn(s.UserProfileBtn__btn, className)}
      aria-label="user-profile"
      variant="outlined"
      endIcon={<ArrowDropDownIcon />}
      onClick={handleClick}
    >
      <span className={s.UserProfileBtn__btnText}>{title}</span>
      <Menu
        className={s.UserProfileBtn__menu}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        disableScrollLock={true}
        TransitionProps={{ timeout: { enter: 0, exit: 0 } }}
      >
        {authDetails.isApproved && (
          <MenuItem
            className={s.UserProfileBtn__item}
            onClick={() => navigateToUrl('/profile/personal')}
          >
            <span className={s.UserProfileBtn__icon}>
              <ProfileIcon />
            </span>
            <ListItemText>{'My Profile'}</ListItemText>
          </MenuItem>
        )}
        {!authDetails.isApproved && (
          <MenuItem className={s.UserProfileBtn__item} onClick={redirectUnapprovedUser}>
            <span className={s.UserProfileBtn__icon}>
              <ProfileIcon />
            </span>
            <ListItemText>
              {!authDetails.kycDone
                ? 'Complete registration'
                : !authDetails.investorAccredited
                ? 'Update my details'
                : 'Complete registration'}
            </ListItemText>
          </MenuItem>
        )}
        <Divider className={s.UserProfileBtn__item} />
        {authDetails.isImpersonated ? (
          <MenuItem className={s.UserProfileBtn__item} onClick={onStopImpersonateUser}>
            <span className={s.UserProfileBtn__icon}>
              <ImpersonateIcon />
            </span>
            <ListItemText>{'Stop Impersonating'}</ListItemText>
          </MenuItem>
        ) : (
          <MenuItem className={s.UserProfileBtn__item} onClick={onSignOut}>
            <span className={s.UserProfileBtn__icon}>
              <LogoutIcon />
            </span>
            <ListItemText>{'Sign Out'}</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </Button>
  );
};

export default UserProfileBtn;
